var ALL_CSS_DIRECTIONS = {
    top: true,
    right: true,
    bottom: true,
    left: true,
};
var removeLayoutPaddingMixin = function (directions) {
    if (directions === void 0) { directions = ALL_CSS_DIRECTIONS; }
    return "\n  ".concat(directions.top ? 'margin-top: calc(0px - var(--layout-top-padding));' : '', "\n  ").concat(directions.right
        ? 'margin-right: calc(0px - var(--layout-right-padding));'
        : '', "\n  ").concat(directions.bottom
        ? 'margin-bottom: calc(0px - var(--layout-bottom-padding));'
        : '', "\n  ").concat(directions.left
        ? 'margin-left: calc(0px - var(--layout-left-padding));'
        : '', "\n");
};
var addLayoutPaddingMixin = function (directions) {
    if (directions === void 0) { directions = ALL_CSS_DIRECTIONS; }
    return "\n  ".concat(directions.top ? 'padding-top: var(--layout-top-padding);' : '', "\n  ").concat(directions.right ? 'padding-right: var(--layout-right-padding);' : '', "\n  ").concat(directions.bottom ? 'padding-bottom: var(--layout-bottom-padding);' : '', "\n  ").concat(directions.left ? 'padding-left: var(--layout-left-padding);' : '', "\n");
};
export var mixins = {
    removeLayoutPadding: removeLayoutPaddingMixin,
    addLayoutPadding: addLayoutPaddingMixin,
};
//# sourceMappingURL=mixins.js.map